import { Controller } from "stimulus";

// Grows the thread title textarea to fit its text. The character counter is the shared
// character-count controller.
export default class TitleController extends Controller {
  connect() {
    this.boundUpdate = this.update.bind(this)
    this.update()
    this.inputTarget.addEventListener('input', this.boundUpdate)
  }

  disconnect() {
    this.inputTarget.removeEventListener('input', this.boundUpdate)
  }

  update() {
    this.inputTarget.style.height = 'auto'
    this.inputTarget.style.height = this.inputTarget.scrollHeight + 'px'
  }
}

TitleController.targets = ["input"]
